import { useEffect, useRef, useState } from "react";
import RouteSummary from "../../../../services/AuraCamera/routes/route_summary";
import CommonPanel from "../../../common/common-panel";
import Table from "./components/table";
import LoadingScreen from "../../../common/Loading";
// Localisation
import { useTranslation } from "react-i18next";
import Helpers from "../../../../utils/helpers";
import { Toast } from "primereact/toast";
interface Active {
  gridActive?: string;
  tableActive?: string;
}

const Index = () => {
  const toast = useRef<any>(null);
  const [isGrid, layoutToggle] = useState(false);
  const { t } = useTranslation();
  const [isLoading, isLoadingUpdate] = useState(false);
  const [activeClass, setActiveClass] = useState<Active>({
    gridActive: "",
    tableActive: "icon-active",
  });
  const [routeTableValues, setRouteTableValues] = useState<any>([]);

  useEffect(() => {
    isLoadingUpdate(true);
    RouteSummary.GetRouteSummary().then((route_summary_route: any) => {
      if (route_summary_route == "error") {
        toast?.current?.clear();
        toast?.current?.show({
          severity: "error",
          summary: "Something went wrong",
          detail: "Unable to fetech data, Please try again",
          life: 3000,
        });

        isLoadingUpdate(false);
      } else {
        setRouteTableValues(route_summary_route);
        isLoadingUpdate(false);
      }
    });
  }, []);
  const handleLayout = (childvalue: any) => {
    layoutToggle(childvalue);
    if (childvalue === true) {
      setActiveClass({
        gridActive: "icon-active",
        tableActive: "",
      });
    } else {
      setActiveClass({
        gridActive: "",
        tableActive: "icon-active",
      });
    }
  };
  const handleDownload = () => {
    let routeTableValuesDeepCopy = JSON.parse(JSON.stringify(routeTableValues));

    let CalculatedFilteredValues: any = routeTableValuesDeepCopy;

    CalculatedFilteredValues.map((table_vals: any) => {
      const sum = table_vals?.obs_sequence_targets?.reduce(
        (a: number, b: number) => a + b
      );
      table_vals.totalTarget = sum;
    });

    Helpers.exportToCSV(
      CalculatedFilteredValues,
      "Route_summart",
      "Route_summart",
      {
        routeName: "Route name",
        siteName: "Site name",
        cameraOperator: "Camera operator",
        customer: "Customer",
        total_observations: "Total Observations #",
        totalTarget: "Total Targets #",
      },
      [
        "routeName",
        "siteName",
        "cameraOperator",
        "customer",
        "total_observations",
        "totalTarget",
      ]
    );
  };

  return (
    <>
      <LoadingScreen isLoading={isLoading} />
      <Toast ref={toast} style={{ marginTop: "25px", zIndex: 9999 }} />
      <nav aria-label="breadcrumb" className="breadcrumb--wrapper">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>{"Routes"}</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            <a>{"Route Summary"}</a>
          </li>
        </ol>
      </nav>
      <div className="content__header">
        <div className="content__wrap">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <h4 className="page-heading">{"Route Summary"}</h4>
            </div>
          </div>
        </div>
      </div>

      {/* Main Box Start */}
      <div className="content__boxed dashboard_aogi_content_box_first">
        <div className="content__wrap">
          <div className="dashboard_main_div">
            <div className="card all-surveys-table card-mt">
              <CommonPanel
                tableData={handleLayout}
                gridData={handleLayout}
                activeClass={activeClass}
                downloadData={handleDownload}
                InnerComponent={
                  <Table isGrid={isGrid} filteredValues={routeTableValues} />
                }
                Heading={`All Routes`}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Main Box End */}
    </>
  );
};

export default Index;
